import { useEffect } from 'react';

/**
 * SEO Redirect Component
 * Redirects root-level SEO file requests to API endpoints
 * This bypasses SPA routing in production environments
 */
export function RobotsRedirect() {
  useEffect(() => {
    // Redirect to API-served robots.txt
    window.location.replace('/api/robots.txt');
  }, []);
  
  // Return null while redirecting
  return null;
}

export function SitemapRedirect() {
  useEffect(() => {
    // Redirect to API-served sitemap.xml
    window.location.replace('/api/sitemap.xml');
  }, []);
  
  // Return null while redirecting
  return null;
}
